export const developmentHasBlocks = true
export const masterTexturePath = `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/`
